<template>
    <footer class="footer">
        <div class="footer-top">
            <div class="container">
                <div class="footer-link-wrap">

                    <ul class="footer-link">
                        <li><a href="/company">회사소개</a></li>
                        <li><a href="/policy">이용약관</a></li>
                        <li><a href="/privacy">개인정보 취급방침</a></li>
                        <li><a href="/company#green">친환경벽지</a></li>
                    </ul>
                </div>
                <!-- <div class="f-right-logo"><img src="/images/main/f-logo.png" alt=""></div> -->
                <ul class="footer-right">
                    <li><a href="/lmpc/intro">DID LMPC</a></li>
                    <li><a href="https://en.didwallpaper.com/" target="_blank">ENGLISH</a></li>
                    <li class="footer-banner">
                        <a href="https://cafe.naver.com/pcarpenter" target="_blank">
                            <img src="/images/pcarpenter.jpg" alt="">
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="footer-bottom">
            <div class="container">
                <div class="footer-col">
                    <ul class="footer-info">
                        <li>서울특별시 강남구 봉은사로 327(논현동) 궁도빌딩 10층, 12층</li>
                        <li>대표번호 02-2141-3930</li>
                        <li>이메일 customer@didwallpaper.com</li>
                        <li>사업자등록번호 220-85-09219</li>
                        <!-- <li>정보책임자 이돈영</li> -->
                        <li>Copyright (c) 2020 didwallpaper all right reserved.</li>
                    </ul>
                </div>
                <!-- <div class="footer-col">
                    <ul class="footer-customer">
                        <li><img src="/images/icon/footer-customer-chat.png" alt=""></li>
                    </ul>
                </div> -->
            </div>
        </div>
        <quick-menu></quick-menu>
    </footer>
</template>

<script>
import QuickMenu from "@/components/client/inc/quick-menu.vue";

export default {
    components: {
        QuickMenu
    }
}
</script>
